import * as requestFromServer from "./coworkersCrud";

export const fetchCoworkers = (authority) => {
    return requestFromServer.getCoworkers(authority).then(response => {
        return response.data;
    }).catch(error => {
        return [];
    });
};
